import { Api } from 'app/api/@generated/backend';

import { config } from 'app/config/config';
import { StateService } from 'app/services/state-service';

export const api = new Api({
    baseURL: config.BASE_PATH,
    // Uncomment adapter if want to use mock data
    // adapter: _config => mockedDataAdapter(_config),
});

api.instance.interceptors.request.use((request) => {
    const token: string | undefined = StateService.getAccessToken();
    const salesId: string | undefined = StateService.getSalesId();

    if (token && request.headers) {
        request.headers.Authorization = `Bearer ${token}`;
    }

    if (salesId && request.headers) {
        request.headers['X-sales-id'] = salesId;
    }

    return request;
});

api.instance.interceptors.response.use(
    (response) => response,
    (error) =>
        Promise.reject({
            message: error.message,
            code: `${error.response.status}`,
        }),
);
